import { render, staticRenderFns } from "./UserOptions.vue?vue&type=template&id=7a528bf2&scoped=true"
import script from "./UserOptions.vue?vue&type=script&lang=ts"
export * from "./UserOptions.vue?vue&type=script&lang=ts"
import style0 from "./UserOptions.vue?vue&type=style&index=0&id=7a528bf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a528bf2",
  null
  
)

export default component.exports